import { encryptData, decryptData } from "../pages/cryptoUtil";


// utils/logoutService.js
const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;


export const callLogoutAPI = async (logout_reason) => {
  try {
    const userid = sessionStorage.getItem("userId");
    const isHistoryId = sessionStorage.getItem("isHistoryId");
  
const requestData = encryptData({
    data: {
          user_id: userid,
          isHistoryId: isHistoryId,
          logout_reason:logout_reason,
        },
      });

    const response = await fetch(`${apiEndPoint}/logout`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
       body: requestData,
    });

    const result = await response.json();
    

    if (!response.ok) {
      throw new Error(result.message || 'Logout failed');
    }

    const decrypted = decryptData(result);
    console.log(decrypted.data.status);
    return { status: decrypted.data.status, message: decrypted.data.message || 'Logged out successfully' }; 
  } catch (err) {
    console.error("Logout API error:", err.message);
    return { status: 'error', message: err.message };
  }
};
